import { useEffect, type JSX } from "react";
import { ErrorLike } from "@apollo/client";

import useErrorHandle from "hooks/useErrorHandle";

const useErrorHandlerSourceCode = (
  setAccountOrAuthErrorContent?: (content: JSX.Element) => void,
  error?: ErrorLike
) => {
  const AccountOrAuthErrorContent = useErrorHandle(error);

  useEffect(() => {
    if (AccountOrAuthErrorContent) {
      setAccountOrAuthErrorContent?.(AccountOrAuthErrorContent);
    }
  }, [AccountOrAuthErrorContent, setAccountOrAuthErrorContent]);
};

export default useErrorHandlerSourceCode;
